import { IItemGroupsState } from './types';

export const initialSelectors = {
  selectLoadedState: () => false,
  selectSyncState: () => false,
  selectSyncError: () => null,
  selectItemGroups: () => [],
};

export const selectSyncState = (state: IItemGroupsState) => state.syncing;
export const selectLoadedState = (state: IItemGroupsState) => state.loaded;
export const selectSyncError = (state: IItemGroupsState) => state.error;
export const selectItemGroups = (state: IItemGroupsState) => state.itemGroups;
